import { Source } from 'apiConnector/quote-loading';
import { FormLoadingIndicator } from 'components/shared/FormLoadingIndicator/FormLoadingIndicator';
import { FC, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import type { LoadQuoteRouteProps } from './LoadQuoteRoute.connect';
import { connectLoadQuoteRoute } from './LoadQuoteRoute.connect';

const Component: FC<LoadQuoteRouteProps> = ({ onQuoteLoaded }) => {
  const { externalId } = useParams();
  const [params] = useSearchParams();
  const source = (params.get('source') as Source | null) ?? undefined;
  useEffect(() => onQuoteLoaded(externalId!, source), [externalId, onQuoteLoaded, source]);

  return (
    <div className="variations-page page-container">
      <div className="max-width-container">
        <div className="load-quote-form container-fluid q-wrapper quote-request">
          <div>
            <FormLoadingIndicator />
            Loading quote {externalId}
          </div>
        </div>
      </div>
    </div>
  );
};
Component.displayName = 'LoadQuoteRoute';

export const LoadQuoteRoute = connectLoadQuoteRoute(Component);
